// --- Core ---
import {useEffect, useState} from "react";
import {useField} from "react-final-form";

interface FieldListenerProps<FieldValue> {
  // Name of the final form field
  name: string;
  // Handler called with the current and previous value. Only called, when values differ by identity
  onChange: (current: FieldValue, previous: FieldValue) => void;
}

const FieldListener = <FieldValue, >({name, onChange}: FieldListenerProps<FieldValue>) => {
  const {input: {value}} = useField<FieldValue>(name, {subscription: {value: true}});
  const [previous, setPrevious] = useState<FieldValue>(value);

  useEffect(() => {
    if (value !== previous) {
      onChange(value, previous);
      setPrevious(value);
    }
  }, [onChange, previous, value]);

  return null;
};

export {
  FieldListener
};
